module.exports = __webpack_public_path__ + "img/jshopQrcode.a3d30b74.png";